<div class="row">
  <img alt="⏳" class="spinner" src="/assets/default/loading-spinner.svg">
  <div class="message"><ng-content></ng-content></div>
</div>
